import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToId } from "./SmoothScroll";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/site";

export const Header = () => (
  <motion.header
    data-testid="site-header"
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
  >
    <div className="flex items-stretch justify-between">
      <a
        href="#top"
        data-testid="header-logo"
        onClick={(e) => { e.preventDefault(); scrollToId("#top"); }}
        className="flex items-center gap-3 px-5 py-4 md:px-8"
      >
        <span className="flex h-9 w-9 items-center justify-center bg-ember font-display text-sm text-coal-900">MG</span>
        <span className="hidden font-mono text-[11px] uppercase tracking-[0.2em] text-white/80 sm:block">
          Matlock Groundworks<br />& Drainage
        </span>
      </a>

      <nav className="hidden items-center gap-8 font-mono text-[11px] uppercase tracking-[0.2em] text-steel lg:flex">
        <button data-testid="nav-services-link" onClick={() => scrollToId("#services")} className="transition-colors hover:text-ember">Services</button>
        <button data-testid="nav-work-link" onClick={() => scrollToId("#work")} className="transition-colors hover:text-ember">Work</button>
        <button data-testid="nav-quote-link" onClick={() => scrollToId("#quote")} className="transition-colors hover:text-ember">Quote</button>
      </nav>

      <div className="flex items-stretch">
        <a
          href={`tel:${PHONE_TEL}`}
          data-testid="header-phone-link"
          className="hidden items-center gap-2 border-l border-white/10 px-6 font-mono text-xs tracking-[0.15em] text-white/90 transition-colors hover:text-ember md:flex"
        >
          <Phone size={13} className="text-ember" />
          {PHONE_DISPLAY}
        </a>
        <button
          data-testid="header-quote-button"
          onClick={() => scrollToId("#quote")}
          className="group relative overflow-hidden border-l border-white/10 bg-ember px-6 py-4 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-coal-900 md:px-8"
        >
          <span className="absolute inset-0 translate-y-full bg-white transition-transform duration-300 ease-out group-hover:translate-y-0" aria-hidden="true" />
          <span className="relative">Get a quote</span>
        </button>
      </div>
    </div>
  </motion.header>
);
